import React, { useEffect, useContext } from 'react';
import { isEmpty } from 'lodash';
import { useNavigate, useParams } from 'react-router';
import axios from 'axios';
import styled from 'styled-components';
import { Form } from 'react-final-form';
import { Container, Card, Box, Button, Flex, Text } from '../../design-system';
import Alert from '../../helpers/alert';
import { useData } from '../../helpers/data-loader';
import { composeValidators, required, passwordVal } from '../../helpers/utils';
import FieldColumn from '../../components/FieldColumn';
import Logo from '../../components/Logo';
import { ERR_MSG } from '../../globalConstants';
import { ACTIONS, Session } from '../../contexts/sessionContext';

const Wrapper = styled(Container)`
  background-color: ${(p) => p.theme.colors.greyDark};
`;

const MainContainer = styled(Box)`
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background-color: ${(p) => p.theme.colors.greyLightest};
`;

const Brand = styled(Flex)`
  justify-content: center;
  a {
    text-decoration: none;
  }
`;

const FormContainer = styled(Flex)`
  width: 100%;
  align-items: center;
  justify-content: center;
`;
const UserCard = styled(Card)`
  min-width: 600px;
`;

const NewOrgMember = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { dispatch } = useContext(Session);

  const [invite, fetchInvite, __, error] = useData(`/invite/${id}`);

  useEffect(() => {
    fetchInvite();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (error) {
      navigate('/');
    }
  }, [error, navigate]);

  const onSubmit = async (values: any) => {
    try {
      const { data } = await axios.post(`/auth/register-new-user`, values);
      dispatch({ type: ACTIONS.SET_USER, value: data });
      navigate('/');
    } catch (err) {
      // Extract specific error message from axios response
      const errorMessage =
        err.response?.data?.message ||
        err.response?.data?.error ||
        err.message ||
        ERR_MSG;

      Alert.error(errorMessage);
    }
  };

  return (
    <Wrapper fluid gutter={100}>
      <MainContainer>
        <Brand p={10}>
          <Logo width="10.5rem" />
        </Brand>
        {!isEmpty(invite) && (
          <FormContainer mt={35}>
            <UserCard p={30} pt={0}>
              <Card.Header textAlign="center" mt={2} mb={4}>
                <Text fontSize={18}>Register for {invite.agency.name}</Text>
              </Card.Header>
              <Form
                initialValues={{
                  ...invite,
                  agency: invite.agency.name,
                }}
                onSubmit={onSubmit}
                render={({ handleSubmit, submitting, pristine }) => (
                  <form onSubmit={handleSubmit}>
                    <FieldColumn name="email" label="Email" disabled />
                    <FieldColumn name="agency" label="Organization" disabled />
                    <FieldColumn
                      name="name"
                      label="Full Name"
                      validate={required}
                    />
                    <FieldColumn
                      name="password"
                      label="Password"
                      type="password"
                      validate={composeValidators(required, passwordVal)}
                    />
                    <Button.Group
                      display="flex"
                      justifyContent="center"
                      mt={30}
                    >
                      <Button
                        mt={20}
                        mb={20}
                        minWidth={100}
                        type="submit"
                        disabled={submitting || pristine}
                      >
                        Register
                      </Button>
                    </Button.Group>
                  </form>
                )}
              />
            </UserCard>
          </FormContainer>
        )}
      </MainContainer>
    </Wrapper>
  );
};

export default NewOrgMember;
